import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api.createSession(sessionId)
      .then((user) => {
        setUser(user);
        navigate("/", { replace: true, state: { user } });
      })
      .catch((e) => {
        setUser(null);
        navigate("/login", {
          replace: true,
          state: { error: e?.response?.data?.detail || "No se pudo iniciar sesión" },
        });
      });
  }, [location.hash, navigate, setUser]);

  return null;
};
